import type { ReactElement } from "react";

/** Exact structured values, displayed as data rather than an editable JSON dump. */
export function ProposalReviewValue({
  value,
}: {
  value: unknown;
}): ReactElement {
  if (Array.isArray(value)) {
    return value.length === 0 ? (
      <span>Empty list</span>
    ) : (
      <ol className="space-y-2 list-decimal ps-5">
        {value.map((item, index) => (
          <li key={index}>
            <ProposalReviewValue value={item} />
          </li>
        ))}
      </ol>
    );
  }
  if (value !== null && typeof value === "object") {
    const entries = Object.entries(value);
    return entries.length === 0 ? (
      <span>Empty object</span>
    ) : (
      <dl className="space-y-2">
        {entries.map(([key, item]) => (
          <div key={key} className="min-w-0 border-s border-pb-border ps-3">
            <dt className="font-medium break-words text-pb-text-secondary">
              {key}
            </dt>
            <dd className="mt-1">
              <ProposalReviewValue value={item} />
            </dd>
          </div>
        ))}
      </dl>
    );
  }
  return (
    <span className="whitespace-pre-wrap break-words">
      {value === undefined
        ? "—"
        : value === null
          ? "null"
          : value === ""
            ? "Empty text"
            : String(value)}
    </span>
  );
}
